// Production Cloud Functions URL (Firebase Functions v2)
// Format: https://{region}-{project-id}.cloudfunctions.net/{function-name}
const PRODUCTION_BASE_URL = 'https://us-central1-payattable-c0e8c.cloudfunctions.net'

const BASE_URL =
  process.env.REACT_APP_API_BASE_URL ?? PRODUCTION_BASE_URL

/**
 * Fetch mesa data for QR display
 * 
 * ✅ QR ONLY calls this endpoint
 * ❌ QR NEVER talks to Firestore or POS directly
 * 
 * @param ticket - Optional ticket ID (posOrderId). When present, backend ensures mesa matches this ticket (one QR per ticket).
 */
export async function fetchMesaForQR(mesaId: string, ticket?: string) {
  if (!mesaId) {
    throw new Error('mesaId is required')
  }

  const params = new URLSearchParams()
  if (ticket && ticket.trim()) params.set('ticket', ticket.trim())
  const query = params.toString()
  const url = query ? `${BASE_URL}/qrApi/mesa/${mesaId}?${query}` : `${BASE_URL}/qrApi/mesa/${mesaId}`
  const res = await fetch(url)

  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: 'Failed to load mesa' }))
    throw new Error(err.error || 'Failed to load mesa')
  }

  const data = await res.json()
  
  if (!data.success || !data.mesa) {
    throw new Error('Invalid response from QR API')
  }

  return data.mesa
}
